import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {OrderService} from '../../services/order.service';
import {DraftService} from '../../services/draft.service';
import {GeneralService} from '../../services/general.service';
import {UserDataService} from '../../services/user-data.service';
import {MobilePackService} from '../../services/mobile-pack.service';
import {NormalizadorService} from '../../services/normalizador.service';
import {TerminalDeliveryService} from '../../services/terminal-delivery.service';
import {ListadoActivacionesService} from '../../services/listado-activaciones.service';
import {TerminalDeliveryModel} from '../../interface/terminal-delivery-model';
import {UserDataModel} from '../../interface/user-data-model';
import {PriceDelivery} from '../../classes/priceDelivery';
import {DigoService} from 'src/app/services/digo.service';
import {ApiAmenaService} from '../../services/api-amena.service';
import { superStatus } from 'src/app/shared/constantes';
import { AlertDialogComponent } from 'src/app/shared/components/alert-dialog/alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-order-detail',
    templateUrl: './order-detail.component.html',
    styleUrls: ['./order-detail.component.css', '../../../../assets/css/amena-theme.css'],
    standalone: false
})
export class OrderDetailComponent implements OnInit, AfterViewInit {
    public order: any;
    public from: string;
    public updatingAnnotations = false;
    public terminalDelivery: TerminalDeliveryModel;
    public terminalDeliveryTitle: string;

    private orderID: string;
    public pdv: any;
    public disabledButton: boolean = false;
    public customerData: any;
    public numLogis: number;
    public superStatus: any = superStatus;
    public orderNotFound: boolean = false;

    public typeMobile: any = {
        altas: [],
        portas: []
    };
    public cartAgreements: any = {
        cp_price: 0,
        terminals: [],
        vap_price: 0,
        show: false
    };

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private modalService: NgbModal,
        private orderService: OrderService,
        private draftService: DraftService,
        private generalService: GeneralService,
        private userDataService: UserDataService,
        private mobilePackService: MobilePackService,
        private normalizadorService: NormalizadorService,
        protected terminalDeliveryService: TerminalDeliveryService,
        private listadoActivacionesService: ListadoActivacionesService,
        private digoService: DigoService,
        private amenaService: ApiAmenaService,
        private matDialog: MatDialog
    ) {
        this.from = this.activatedRoute.snapshot.paramMap.get('from');
        this.orderID = this.activatedRoute.snapshot.paramMap.get('order_id');
        this.order = history.state.data;
        this.orderNotFound = false;
        this.getNumberLogis();
        this.updateModelTerminal(this.order);
    }

    ngOnInit(): void {
        if (this.order !== null && this.order !== undefined) {
            this.setTerminalDelivery();
        }

        this.digoService.getPDV()
            .subscribe((data) => {
                if (data) {
                    this.pdv = data;
                }
            });
    }

    ngAfterViewInit(): void {
        if (this.order == null) {
            this.orderService.getOrder(this.orderID)
                .subscribe((data: any) => {
                    this.orderNotFound = false;
                    this.order = data.msg;
                    this.getNumberLogis();
                    this.setTypeMobile();
                    this.findCustomer();
                    this.updateModelTerminal(this.order);
                    this.setTerminalDelivery();
                    this.checkHasPortability(this.order);
                }, (error) => {                    
                    this.orderNotFound = true;
                });
        } else {
            this.findCustomer();
        }
    }

    getNumberLogis() {
        this.numLogis = 0;
        if (this.order && this.order.mobiles && this.order.mobiles.length) {
            for (const mobile of this.order.mobiles) {
                if (mobile.delivery_method && mobile.delivery_method.includes('logistica')) {
                    this.numLogis ++;
                }
            }
        }
        return this.numLogis;
    }

    setTypeMobile() {
        if (this.order.mobiles && this.order.mobiles.length) {
            this.typeMobile.portas = this.order.mobiles.filter(mobile => mobile.msisdn !== '');
            this.typeMobile.altas = this.order.mobiles.filter(mobile => mobile.msisdn === '');
        }
    }

    findCustomer() {
        if (this.order.customer_document_type && this.order.customer_document_type.digo_code && this.order.customer_document_type.digo_code !== '' && this.order.customer_document && this.order.customer_document !== '') {
            const body = {
                document_type: this.order.customer_document_type.digo_code,
                document_number: this.order.customer_document
            };
            this.disabledButton = true;
            this.amenaService.getCustomerInfoFromService(body)
                .subscribe((response: any) => {
                    if (response && response.msg) {
                        this.customerData = response.msg;
                        this.productHasAgreement();
                    }
                }, error => {
                    this.disabledButton = false;
                }, () => {
                    this.disabledButton = false;
                });
        }
    }

    reloadPage() {
        location.reload();
    }

    async getOfficesByOrder() {
        let datos: any;
        const response = await this.terminalDeliveryService.getOffices(this.order.mobiles[0].correos_post_code).toPromise()
            .then((data: any) => {
                const office: any = data.filter((item) => {
                    return item.id === this.order.mobiles[0].correos_id;
                });

                if (typeof office[0] !== 'undefined') {
                    this.terminalDelivery = new TerminalDeliveryModel();
                    this.terminalDelivery.type = 1;
                    this.terminalDelivery.deliveryPrice = PriceDelivery.PRICE_ALTA_DIR_CORREOS;
                    this.terminalDelivery.mailData = office[0];
                    this.terminalDelivery.courierData = {
                        zip: this.order.mobiles[0].correos_post_code,
                    };
                    this.terminalDeliveryTitle = 'Entrega en Correos';
                }
            });
        return datos;
    }


    async setTerminalDelivery() {
        let allPortability = null;
        if (this.order.mobiles != null && this.order.mobiles.length > 0) {
            allPortability = this.checkHasPortability(this.order);
        }

        if (this.order.mobiles != null && this.order.mobiles.length > 0 && this.order.mobiles[0].correos_post_code !== '') {
            const data: any = await this.getOfficesByOrder();
        }

        if (this.order.addresses != null) {
            const delivery = this.order.addresses.filter((address) => {
                return address.type === 'delivery';
            });

            const dir_cliente = this.order.addresses.filter((dir) => {
                return dir.type === 'postal';
            });

            // Si la dirección postal y la de entrega son iguales, quiere decir que la opción elegida es envio al cliente.
            const type_entrega = delivery.filter((data) => {
                return data.apartment_number === dir_cliente[0].apartment_number &&
                    data.city === dir_cliente[0].city &&
                    data.country === dir_cliente[0].country &&
                    data.floor_number === dir_cliente[0].floor_number &&
                    data.post_code === dir_cliente[0].post_code &&
                    data.province === dir_cliente[0].province &&
                    data.staircase_number === dir_cliente[0].staircase_number &&
                    data.street_name === dir_cliente[0].street_name &&
                    data.street_number === dir_cliente[0].street_number &&
                    data.street_type === dir_cliente[0].street_type;
            });

            let isMensajeria = null;

            if (typeof type_entrega[0] !== undefined && type_entrega.length > 0) {
                isMensajeria = 3;
            }

            if (typeof delivery[0] !== 'undefined') {

                this.terminalDelivery = new TerminalDeliveryModel();
                this.terminalDelivery.type = isMensajeria !== null ? isMensajeria : 2;
                this.terminalDelivery.deliveryPrice = allPortability === true ? PriceDelivery.PRICE_PORTA_DIR_CONTACTO : PriceDelivery.PRICE_ALTA_DIR_CONTACTO;
                this.terminalDelivery.courierData = {
                    office: '',
                    full_name: this.order.customer_name + ' ' +
                        this.order.customer_last_name + ' ' +
                        this.order.customer_second_last_name,
                    phone: delivery[0].phone_number,
                    road_type: delivery[0].street_type,
                    address: delivery[0].street_name,
                    number: delivery[0].street_number,
                    zip: delivery[0].post_code,
                    city: delivery[0].city,
                    province: delivery[0].province,
                    floor: delivery[0].floor_number,
                    door: delivery[0].apartment_number,
                    stairway: delivery[0].staircase_number,
                    additional_info: delivery[0].additional_info
                };
                this.terminalDeliveryTitle = 'Mensajería';
            }
        }
    }

    checkHasPortability(order) {
        let allPortability = true;
        order.mobiles
            .map(data => {
                if (data.portability === false) {
                    allPortability = false;
                }
            });

        return allPortability;
    }

    getAlertClass(status): string {
        switch (status) {
            case superStatus.in_process:
                return 'alert-dark';
            case superStatus.cancelled:
                return 'alert-danger';
            default:
                return 'alert-dark';
        }
    }

    getAlertTitle(status): string {
        switch (status) {
            case superStatus.in_process:
                return 'En proceso...';
            case superStatus.cancelled:
                return 'Cancelado';
            case superStatus.error:
                return 'Error';
            case superStatus.active:
                return 'Activado';
            default:
                return 'En proceso...';
        }
    }

    getAlertDescription(order): string {
        if (order.super_status === superStatus.cancelled || order.super_status === superStatus.error) {
            return order.error_description && order.error_description !== '' ? order.error_description : 'El alta de los servicios se ha cancelado.';
        } else {
            if (order.type === 'convergent') {
                const textFibra = (order.broadband && order.broadband.msisdn && order.broadband.msisdn !== '') ? 'La portabilidad' : 'El alta';
                if (this.typeMobile.altas.length && this.typeMobile.portas.length === 0) {
                    const text = (this.typeMobile.altas.length > 1) ? 'las líneas móviles' : 'la línea móvil';

                    return 'El alta de ' + text + ' ya se ha realizado. ' + textFibra + ' del fijo se ha enviado y se ha iniciado el proceso para su activación.';
                } else if (this.typeMobile.altas.length === 0 && this.typeMobile.portas.length) {
                    const text = (this.typeMobile.portas.length > 1) ? 'las líneas móviles' : 'la línea móvil';

                    return textFibra + ' del fijo y la portabilidad de ' + text + ' se ha enviado y se ha iniciado el proceso para su activación.';
                } else {
                    const text = (this.typeMobile.altas.length > 1) ? 'las líneas móviles' : 'la línea móvil';
                    const text2 = (this.typeMobile.portas.length > 1) ? 'las líneas móviles' : 'la línea móvil';

                    return 'El alta de ' + text + ' ya se ha realizado. ' + textFibra + ' del fijo y la portabilidad de ' + text2 + ' se ha enviado y se ha iniciado el proceso para su activación.';
                }
            } else if (order.type === 'mobile') {
                if (this.typeMobile.altas.length && this.typeMobile.portas.length === 0) {
                    const text = (this.typeMobile.altas.length > 1) ? 'las líneas móviles' : 'la línea móvil';

                    return 'El alta de ' + text + ' ya se ha realizado.';
                } else if (this.typeMobile.altas.length === 0 && this.typeMobile.portas.length) {
                    const text = (this.typeMobile.portas.length > 1) ? 'las líneas móviles' : 'la línea móvil';

                    return 'La portabilidad de ' + text + ' se ha enviado y se ha iniciado el proceso para su activación.';
                } else {
                    const text = (this.typeMobile.altas.length > 1) ? 'las líneas móviles' : 'la línea móvil';
                    const text2 = (this.typeMobile.portas.length > 1) ? 'las líneas móviles' : 'la línea móvil';

                    return 'El alta de ' + text + ' ya se ha realizado. La portabilidad de ' + text2 + ' se ha enviado y se ha iniciado el proceso para su activación.';
                }
            } else {
                return 'El alta de la fibra se ha enviado y se ha iniciado el proceso para su activación.';
            }
        }
    }

    getContractNumber(order): string {
        let contractNumber: string;

        if (order.type === 'convergent' && order.broadband != null && order.broadband.order_amena != null) {
            contractNumber = order.broadband.order_amena.amena_contract_number;
        } else if (order.mobiles != null && order.mobiles.length > 0) {
            contractNumber = order.mobiles[0].order_amena.amena_contract_number;
        }

        return contractNumber !== null ? contractNumber : '--';
    }

    updateAnnotation(order, annotation) {
        this.updatingAnnotations = true;

        this.listadoActivacionesService.updateAnnotation(order.order_id, annotation).subscribe(data => {
            order.annotation = annotation;
            this.updatingAnnotations = false;
        }, error => {
            this.updatingAnnotations = false;
        });
    }

    getTerminalMonthlyPrice(mobile): number {
        let price = parseFloat(mobile.rate.price);

        if (mobile.rate.increase) {
            price += parseFloat(mobile.rate.increase);
        }
        if (mobile.terminal_vap) {
            price += parseFloat(mobile.terminal.payment_quota);
        }

        return price;
    }

    getTerminalInitialPrice(mobile): number {
        if (mobile.terminal == null) {
            return 0;
        }

        return mobile.terminal_vap ? parseFloat(mobile.terminal.initial_payment) : parseFloat(mobile.terminal.price);
    }

    getTerminalsWithInitialPayment(mobiles): any[] {
        const terminals = [];

        mobiles.forEach((mobile, index) => {
            if (mobile.terminal != null && this.getTerminalInitialPrice(mobile) > 0) {
                terminals.push(mobile);
            }
        });

        return terminals;
    }

    getWithoutIVA(num: number): number {
        return num / 1.21;
    }

    getTotalMonthlyPrice(mobiles): number {
        let price = 0;

        mobiles.forEach((mobile, index) => {
            price += this.getTerminalMonthlyPrice(mobile);
        });

        return price;
    }

    getTotalInitialPrice(mobiles): number {
        let price = 0;

        mobiles.forEach((mobile, index) => {
            price += this.getTerminalInitialPrice(mobile);
        });

        if (this.terminalDelivery != null) {
            price += this.terminalDelivery.deliveryPrice * (this.numLogis !== 0 ? this.numLogis : 1);
        }

        return price;
    }

    getTotalDiscount(mobiles) {
        let prices = mobiles.map((mobile) => {
            return parseFloat(mobile.principal && mobile.rate.type !== 'mobile' ? mobile.rate.price - 21 : mobile.rate.price);
        });

        prices = prices.sort((a, b) => {
            return b - a;
        });

        prices.shift();

        return prices.reduce((a, b) => a + b, 0) * 0.5;
    }

    getTotalMonthlyPriceWithDiscount(mobiles) {
        return this.getTotalMonthlyPrice(mobiles) - this.getTotalDiscount(mobiles);
    }

    getNumberOfPendingDocuments(mobiles): number {
        let num = 0;

        mobiles.forEach((mobile, index) => {
            if (mobile.order_amena == null || mobile.order_amena.amena_order_id == null || mobile.order_amena.status !== 7) {
                num += 1;
            }
        });

        return num;
    }

    getDocumentsDescription(mobiles): string {
        let ready = 0;
        let pending = 0;
        let description = '';

        mobiles.forEach((mobile, index) => {
            if (mobile.order_amena && mobile.order_amena.amena_order_id && mobile.has_docs) {
                ready += 1;
            } else {
                pending += 1;
            }
        });

        if (ready > 0) {
            description += ready + (ready === 1 ? ' documento disponible' : ' documentos disponibles');
        }

        if (pending > 0) {
            description += description !== '' ? ' y ' : '';
            description += pending + (pending === 1 ? ' documento pendiente' : ' documentos pendientes');
        }

        return description;
    }

    getDataUser(order) {
        const userData = new UserDataModel();

        userData.doctype = order.customer_document_type != null ? order.customer_document_type.digo_code : null;
        userData.doc = order.customer_document;
        userData.country = order.customer_nationality != null ? order.customer_nationality.code : null;
        userData.firstName = order.customer_name;
        userData.surname1 = order.customer_last_name;
        userData.surname2 = order.customer_second_last_name;
        userData.birthday = order.customer_birth_date;
        userData.sex = order.customer_gender !== null && order.customer_gender !== '' ? order.customer_gender : '';
        userData.phone = order.customer_phone_number;
        userData.email = order.customer_email;
        userData.bankingData.bank_account = order.iban;

        if (order.payer !== null) {
            userData.bankingData.account_doctype = order.payer.document_type.digo_code;
            userData.bankingData.account_doc = order.payer.document;
            userData.bankingData.account_firstName = order.payer.name;
            userData.bankingData.account_surname1 = order.payer.last_name;
            userData.bankingData.account_surname2 = order.payer.second_last_name;
        }

        for (const address of order.addresses) {
            if (address.type === 'postal') {
                userData.country = address.country;
                userData.tipoVia = address.street_type;
                userData.nombreVia = address.street_name;
                userData.numero = address.street_number;
                userData.codigoPostal = address.post_code;
                userData.localidad = address.city;
                userData.provincia = address.province;
                userData.escalera = address.staircase_number;
                userData.planta = address.floor_number;
                userData.puerta = address.apartment_number;
            }
        }

        return userData;
    }

    getDataBankForm(order) {
        let userDataBankForm: any;

        if (order.payer == null) {
            userDataBankForm = {
                bank_account: order.iban,
                account_doctype: order.customer_document_type && order.customer_document_type.digo_code ? order.customer_document_type.digo_code : null,
                account_doc: order.customer_document,
                // account_country: order.customer_nationality ? order.customer_nationality.code : null,
                account_firstName: order.customer_name,
                account_surname1: order.customer_last_name,
                account_surname2: order.customer_second_last_name,
                account_company: '',
            };
        } else {
            userDataBankForm = {
                bank_account: order.iban,
                account_doctype: order.payer.document_type.digo_code,
                account_doc: order.payer.document,
                // account_country: '',
                account_firstName: order.payer.name,
                account_surname1: order.payer.last_name,
                account_surname2: order.payer.second_last_name,
                account_company: '',
            };
        }

        return userDataBankForm;
    }


    downloadDocument(amena_order_id, number) {
        this.orderService.getDocument(amena_order_id)
            .subscribe((resultBlob: Blob) => {
                if (resultBlob) {
                    this.openInNewTab(resultBlob);
                    // this.downlandFile(resultBlob, number)
                }
            });
    }

    downloadDocumentPrivacy(amena_order_id, number) {
        this.orderService.getDocumentPrivacy(amena_order_id)
            .subscribe((resultBlob: Blob) => {
                window.open(URL.createObjectURL(resultBlob), '_blank');
                if (resultBlob) {
                    this.openInNewTab(resultBlob);
                    // this.downlandFile(resultBlob, number)
                }
            });
    }

    openInNewTab(file) {
        // Abrir en otra pestaña
        window.open(URL.createObjectURL(file), '_blank');
    }

    downlandFile(file, number) {
        // Descargar documento
        let url = window.URL.createObjectURL(file);
        let a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = 'Contrato ' + number;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
    }

    openModal(content) {
        this.modalService.open(content, {size: 'md', centered: true});
    }

    async continueProcess(order: any) {
        const url = (order.hasOwnProperty('broadband') && order.broadband !== null) ? 'amena/convergente' : 'amena/solo_movil';
        this.resumeOrder(order, url);
    }

    getTypeAccessByName(access) {
        const fibra = 'ftth_dir';
        const fibra_ind = 'ftth_ind';
        const adsl = 'adsl';
        switch (access) {
            case 'FTTH_XPJ':
                return fibra;
                break;
            case 'FTTH_NEBA':
                return fibra_ind;
                break;
            case 'DIRECTO':
                return adsl;
                break;
            default:
                return '';
                break;
        }
    }

    resumeOrder(order: any, url: string) {
        let userData = new UserDataModel();
        let userDataBankForm: any;
        let normalizacionForm: any;
        let coberturaForm: any;
        let landlineConfigurationForm: any;
        let isMigration: boolean = false;
        let isMigrationWithPostpaid: boolean = false;
        let isMigrationWithFibra: boolean = false;
        const mobilePacks: any[] = [];
        userData = this.getDataUser(order);
        userDataBankForm = this.getDataBankForm(order);
        let technologies = {
            access: '',
            name: '',
            real: true
        };
        // Añadimos datos dirección entrega terminal
        userData.terminalDelivery = this.terminalDelivery;

        if (order.broadband != null) {
            landlineConfigurationForm = {
                type_operation: order.broadband.portability ? 'portability' : 'registration',
                phone_portability: order.broadband.msisdn,
                operator_portability: order.broadband.service_provider_id,
                cp_vat: +order.broadband.cp_vat,
                cp_price: +order.broadband.cp_price,
                cp_price_without_vat: +order.broadband.cp_price_without_vat                
            };
            if (landlineConfigurationForm.phone_portability && landlineConfigurationForm.phone_portability !== '' && (!landlineConfigurationForm.operator_portability || landlineConfigurationForm.operator_portability === '')) {
                landlineConfigurationForm.type_operation = 'migration';
                isMigration = true;
                isMigrationWithPostpaid = true;
                isMigrationWithFibra = true;
            }
        }

        for (const address of order.addresses) {
            if (address.type === 'installation') {
                normalizacionForm = {
                    codigoPostalNormaliza: address.post_code,
                    localidadNormaliza: address.city,
                    nombreViaNormaliza: address.street_name,
                    numeroNormaliza: address.street_number,
                    provinciaNormaliza: address.province,
                    tipoViaNormaliza: address.street_type,
                };

                coberturaForm = {
                    localidadCobertura: address.city,
                    direccionesCobertura: address.street_name,
                    tipoViaCobertura: address.street_type,
                    nombreViaCobertura: address.street_name,
                    numeroCobertura: address.street_number,
                    provinciaCobertura: address.province,
                    codigoPostalCobertura: address.post_code,
                    plantaCobertura: address.floor_number,
                    bisCobertura: '',
                    bloqueCobertura: '',
                    portalCobertura: '',
                    escaleraCobertura: address.staircase_number,
                    tipoPuertaCobertura: '',
                    puertaCobertura: '',
                    resultadoConsultaCobertura: {
                        cimaArvatoCode: order.broadband != null ? order.broadband.cima_arvato_code : null,
                        cimaINETownCode: order.broadband != null ? order.broadband.cima_ine_town_code : null,
                        cimaGescalCode: order.broadband != null ? order.broadband.cima_gescal_code : null,
                        cimaUniqueEntity: order.broadband != null ? order.broadband.cima_unique_entity : null,
                        cimaPortalCode: order.broadband != null ? order.broadband.cima_portal_code : null,
                        migaCode: order.broadband != null ? order.broadband.miga_code : null,
                        access: order.broadband != null ? order.broadband.access : null,
                        cimaBlockCode: order.broadband != null ? order.broadband.cima_block_code : null,
                        cimaBisCode: order.broadband != null ? order.broadband.cima_bis_code : null,
                        cimaStairCode: order.broadband != null ? order.broadband.cima_stair_code : null,
                        cimaStairOtherCode: order.broadband != null ? order.broadband.cima_stair_other_code : null
                    },
                    portabilidadFijo: order.broadband !== null ? order.broadband.msisdn : '',
                    tipoAltaFijo: '',
                    serviceProviderFijo: order.broadband !== null ? order.broadband.service_provider_id : '',
                    tiposAccesoRetramita: '',
                    numeroApartamento: address.apartment_number
                };
                technologies.name = order.broadband != null ? order.broadband.access : null;
                technologies.access = order.broadband != null ? this.getTypeAccessByName(order.broadband.access) : null;
                if (coberturaForm !== null && coberturaForm !== undefined) {
                    coberturaForm.tiposAccesoRetramita = technologies;
                }
            }

        }
        order.mobiles.forEach((mobile, index) => {
            const stepper_index = index + (order.type === 'convergent' ? 1 : 0);
            mobilePacks.push({
                type_operation: mobile.delivery_method,
                // type_operation: mobile.portability ? ((mobile.new_iccid && mobile.new_iccid !== '') ? 'portability' : 'portability_logistica') : ((mobile.new_iccid && mobile.new_iccid !== '') ? 'registration' : 'registration_logistica'),
                rate: mobile.rate,
                principal: mobile.principal,
                portability_phone: mobile.msisdn !== null ? mobile.msisdn : '',
                portability_operator: mobile.service_provider_id,
                portability_type_client: mobile.old_contract_type,
                portability_iccid: mobile.old_iccid,
                portability_client: '',
                iccid: mobile.new_iccid,
                terminal: mobile.terminal,
                terminal_payment_type: mobile.terminal_vap ? 'VAP' : 'unico',
                terminal_insurance: '',
                stepper_index: stepper_index,
                resegmentation: mobile.resegmentation,
                resegmentation_from_type: mobile.resegmentation_from_type,
                resegmentation_type: mobile.resegmentation_type,
                cp_vat: mobile.vat,
                cp_price: mobile.price,
                cp_price_without_vat: mobile.price_without_vat,
            });
            if (mobile.principal === true) {
                technologies.access = mobile.rate.type !== null ? mobile.rate.type : '';
                if (coberturaForm !== null && coberturaForm !== undefined) {
                    coberturaForm.tiposAccesoRetramita = technologies;
                }
            }
            if (mobile.resegmentation && mobile.resegmentation_from_type !== '') {
                mobilePacks[index].type_operation = 'migration';
                isMigration = true;
                if (mobile.resegmentation_type && mobile.resegmentation_type === 'postpaid') {
                    isMigrationWithPostpaid = true;
                }
            }
        });

        if (order.super_status === superStatus.draft) {
            console.log('[RESUME ORDER - UserData]', userData);
            console.log('[RESUME ORDER - UserDataBank]', userDataBankForm);
            console.log('[RESUME ORDER - Normalización]', normalizacionForm);
            console.log('[RESUME ORDER - Cobertura]', coberturaForm);
            console.log('[RESUME ORDER - MobilePacks]', mobilePacks);
            console.log('[RESUME ORDER - TerminalDelivery]', this.terminalDelivery);
            if (isMigration) {
                this.amenaService.setDataFromCustomer(this.customerData);
                this.normalizadorService.setClientIsCover(true);
                this.amenaService.setMigrationData({
                    migrationshowBanking: isMigrationWithPostpaid,
                    migrationFibra: isMigrationWithFibra
                });
            } else {
                this.normalizadorService.setClientIsCover(false);
                this.amenaService.setDataFromNotCustomer(this.order);
            }
            this.draftService.orderInit();
            this.draftService.setOrderIdDraft(order.order_id);
            this.draftService.setResumeOrderDraftId(order.order_id);
            this.generalService.setEmptyFormNormalizacion(normalizacionForm);
            this.generalService.setEmptyFormCobertura(coberturaForm);
            this.generalService.setEmptyFormLandlineConfiguration(landlineConfigurationForm);
            this.generalService.setEmptyFormMobilePackAll(mobilePacks);
            this.generalService.setEmptyFormUserData(userData);
            this.generalService.setEmptyFormUserDataBank(userDataBankForm);
            this.generalService.setEmptyFormTerminalDelivery(this.terminalDelivery);
            this.normalizadorService.setErrorPeticionCobertura(false);
        }

        this.modalService.dismissAll();
        this.router.navigate([url]);
    }

    resumeOrderUser(order: any, url: string) {
        let userData = new UserDataModel();
        let userDataBankForm: any;
        userData = this.getDataUser(order);
        userDataBankForm = this.getDataBankForm(order);

        this.draftService.orderInit();
        this.generalService.setEmptyFormUserData(userData);
        this.generalService.setEmptyFormUserDataBank(userDataBankForm);
        this.normalizadorService.setErrorPeticionCobertura(false);

        this.modalService.dismissAll();
        this.router.navigate([url]);
    }

    updateModelTerminal(order) {
        if (order && order.mobiles && order.mobiles.length) {
            order.mobiles.forEach(element => {
                if (element.terminal && element.terminal.payments) {
                    let found;
                    if (element.portability) {
                        found = element.terminal.payments.find(x => x.order_type === 'portability');
                    } else {
                        found = element.terminal.payments.find(x => x.order_type === 'new_order');
                    }
                    if (found) {
                        element.terminal.price = found.price;
                        element.terminal.initial_payment = found.initial_payment;
                        element.terminal.payment_quota = found.payment_quota;
                        element.terminal.payment_months = found.payment_months;
                    }
                }
            });
        }
    }

    productHasAgreement() {
        this.cartAgreements = {
            cp_price: 0,
            terminals: [],
            vap_price: 0,
            show: false
        };
        if (this.customerData && this.customerData.products && this.order && this.order.mobiles.length) {
            var found = this.customerData.products
                .filter(product => this.order.mobiles.some(item => (item.msisdn === product.msisdn)))
            if (found && found.length) {
                found.map(product => {
                    if (product.type !== 'broadband' && product.agreements && product.agreements.length) {
                        product.agreements.map(agreement => {
                            if (agreement.type === 'CP' && agreement.price > 0) {
                                this.cartAgreements.cp_price += agreement.price;
                                this.cartAgreements.show = true;
                            }
                        })
                    }

                    if (product.terminal && product.terminal !== '' && product.terminal.agreement && product.terminal.agreement.type === 'VAP') {
                        this.cartAgreements.terminals.push(product.terminal);
                        this.cartAgreements.vap_price += product.terminal.pending_payment;
                        this.cartAgreements.show = true;
                    }
                })
            }
        }
    }

    hasDocs() {
        let found: boolean = false;
        if (this.order.mobiles && this.order.mobiles.length) {
            found = this.order.mobiles.find(mobile => mobile.has_docs);
        }
        return found;
    }

    removeDraft() {
        if (this.pdv.permissions.SAMPLE_MODE && this.pdv.permissions.SAMPLE_MODE === 'SAMPLE') {
            this.matDialog.open(AlertDialogComponent, {
                data: {message: 'Usuario demostración. No se puede eliminar un borrador'}
            });
        } else {
            if (this.order && this.order.order_id && this.order.order_id !== '') {
                this.draftService.removeDraft(this.order.order_id)
                    .subscribe((response) => {
                        console.log('Order borrada');
                        this.router.navigate(['/amena/listado']);
                    }, (error) => console.log('Error al borrar la order'));
            }
        }
    }
}
